/**
 * Куди йти після вибору акаунта на /select-tenant: `state.next` (ч.1072 —
 * після реєстрації це «Обліковий запис»), інакше головна. Лише внутрішня
 * адреса: зовнішню, `//host` чи `/\\host` не приймаємо (відкритий редирект).
 */
export function nextAfterSelect(state: unknown): string {
  const next = (state as { next?: unknown } | null)?.next;
  return typeof next === 'string' && next.startsWith('/') && !next.startsWith('//')
    && !next.startsWith('/\\') ? next : '/';
}
